import { render } from "./ChamadasPublicas.vue?vue&type=template&id=d88e66a0"
import script from "./ChamadasPublicas.vue?vue&type=script&lang=js"
export * from "./ChamadasPublicas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__